<template>
    <div class="h1">{{ isAddMode ? 'Add New Officer' : 'Update Profile' }}</div>
    
    <div class="profile-form-container">

        <!--Personal Information-->
        <div class="form-section">
            <div class="section-title">Personal Information</div>

            <div class="form-row">
                <label>First Name <span class="required">*</span></label>
                <input type="input" v-model="formData.FirstName">
            </div>

            <div class="form-row">
                <label>Last Name <span class="required">*</span></label>
                <input type="input" v-model="formData.LastName">
            </div>

            <div class="form-row">
                <label>Previously Known As</label>
                <input type="input" v-model="formData.PreviouslyKnownAs">
            </div>

            <div class="form-row">
                <label>Mobile <span class="required">*</span></label>
                <input type="input" v-model="formData.MobileNumber">
            </div>

            <div class="form-row">
                <label>Email <span class="required">*</span></label>
                <input type="input" v-model="formData.Email">
            </div>

            <div class="form-row">
                <label>Phone2</label>
                <input type="input" v-model="formData.Phone2">
            </div>
        </div>

        <!--Work Information-->
        <div class="form-section">
            <div class="section-title">Work Information</div>

            <div class="form-row">
                <label>Company <span class="required">*</span></label>
                <select v-model="formData.SecurityCompanyId">
                    <option value="">Select Company</option>
                    <option v-for="company in companiesList" :key="company.companyId" :value="company.companyId">
                        {{ company.companyName }}
                    </option>
                </select>
            </div>

            <div class="form-row">
                <label>SIA No. <span class="required">*</span></label>
                <input type="input" v-model="formData.SiabadageNumber">
            </div>

            <div class="form-row">
                <label>SIA Exp. Date <span class="required">*</span></label>
                <div class="date-input-group">
                    <span class="date-display">({{formatDateForDisplay(formData.SiaExpiryDate)}})</span>
                    <input type="date" v-model="formData.SiaExpiryDate">
                </div>
            </div>

            <div class="form-row">
                <label>NI/UTR <span class="required">*</span></label>
                <input type="input" v-model="formData.Ninumber">
            </div>
        </div>

        <!--Address Information-->
        <div class="form-section">
            <div class="section-title">Address Information</div>

            <div class="form-row">
                <label>House Name/Number <span class="required">*</span></label>
                <input type="input" v-model="formData.HouseNameNumber">
            </div>

            <div class="form-row">
                <label>Street</label>
                <input type="input" v-model="formData.StreetAdress">
            </div>

            <div class="form-row">
                <label>City <span class="required">*</span></label>
                <select v-model="selectedCityName">
                    <option v-for="city in cityList" :key="city.cityId" :value="city.name">{{ city.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>County</label>
                <input type="input" v-model="formData.County">
            </div>

            <div class="form-row">
                <label>PostCode <span class="required">*</span></label>
                <input type="input" v-model="formData.PostCode">
            </div>

            <div class="form-row">
                <label>Country <span class="required">*</span></label>
                <select v-model="selectedAddressCountry">
                    <option v-for="n in nationalityList" :key="n.id" :value="n.name">{{ n.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>Conveyance <span class="required">*</span></label>
                <select v-model="selectedConveyanceName">
                    <option v-for="conveyance in conveyanceListArray" :key="conveyance.id" :value="conveyance.name">{{ conveyance.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>Emergency Contact <span class="required">*</span></label>
                <input type="input" v-model="formData.NextOfKin">
            </div>
        </div>

        <!--Origin Information-->
        <div class="form-section">
            <div class="section-title">Origin Information</div>

            <div class="form-row">
                <label>Date Of Birth <span class="required">*</span></label>
                <div class="date-input-group">
                    <span class="date-display">({{formatDateForDisplay(formData.DateOfBirth)}})</span>
                    <input type="date" v-model="formData.DateOfBirth">
                </div>
            </div>

            <div class="form-row">
                <label>Country Of Birth <span class="required">*</span></label>
                <select v-model="selectedCountryOfBirth">
                    <option v-for="n in nationalityList" :key="n.id" :value="n.name">{{ n.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>Nationality <span class="required">*</span></label>
                <select v-model="selectedNationality">
                    <option v-for="n in nationalityList" :key="n.id" :value="n.name">{{ n.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>Gender <span class="required">*</span></label>
                <select v-model="selectedGenderType">
                    <option v-for="g in genderList" :key="g.id" :value="g.name">{{ g.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>Place Of Birth <span class="required">*</span></label>
                <input type="input" v-model="formData.PlaceOfBirth">
            </div>
        </div>

        <!--Passport Information-->
        <div class="form-section">
            <div class="section-title">Passport Information</div>

            <div class="form-row">
                <label>Passport No</label>
                <input type="text" v-model="formData.PassportNo">
            </div>

            <div class="form-row">
                <label>Expires On</label>
                <div class="date-input-group">
                    <span class="date-display">({{formatDateForDisplay(formData.PassportExpiryDate)}})</span>
                    <input type="date" v-model="formData.PassportExpiryDate">
                </div>
            </div>

            <div class="form-row">
                <label>Visa Expires</label>
                <div class="date-input-group">
                    <span class="date-display">({{formatDateForDisplay(formData.VisaExpiryDate)}})</span>
                    <input type="date" v-model="formData.VisaExpiryDate">
                </div>
            </div>
        </div>

        <!--Identity Document Information-->
        <div class="form-section">
            <div class="section-title">Identity Document Information</div>

            <div class="form-row">
                <label>ID Document <span class="required">*</span></label>
                <select v-model="selectedIdDocumentName">
                    <option v-for="dt in documentTypesList" :key="dt.id" :value="dt.name">{{ dt.name }}</option>
                </select>
            </div>

            <div class="form-row">
                <label>Number <span class="required">*</span></label>
                <input type="input" v-model="idDocumentNumber">
            </div>

            <div class="form-row">
                <label>Issue Date <span class="required">*</span></label>
                <div class="date-input-group">
                    <span class="date-display">({{formatDateForDisplay(idDocumentIssueDate)}})</span>
                    <input type="date" v-model="idDocumentIssueDate">
                </div>
            </div>

            <div class="form-row">
                <label>Expiry Date <span class="required">*</span></label>
                <div class="date-input-group">
                    <span class="date-display">({{formatDateForDisplay(idDocumentExpiryDate)}})</span>
                    <input type="date" v-model="idDocumentExpiryDate">
                </div>
            </div>

            <div class="form-row">
                <label>Issued By <span class="required">*</span></label>
                <select v-model="selectedIdDocumentCountryOfIssue">
                    <option v-for="n in nationalityList" :key="n.id" :value="n.name">{{ n.name }}</option>
                </select>
            </div>

            <div class="form-row checkbox-row">
                <input type="checkbox" v-model="isPrivacyPolicyAgreed">
                <label>By Submitting this form you agree to our <a href="https://eaglesecurityltd.co.uk/privacy-policy-2" target="blank">Privacy Policy</a></label>
            </div>
        </div>

        <div class="button-row">
            <button type="button" class="btn-primary" @click="UpdateOfficer" :disabled="isSaving">
                {{ isSaving ? 'Saving...' : (isAddMode ? 'Add Officer' : 'Save') }}
            </button>
        </div>

    </div>
</template>

<script lang="ts">
    import router from '@/router'
    import { ref, onMounted, watch } from "vue"

    export default({
        name: "profileView",
        props: {
            baseUrl: String,
            officerId: {
                type: String,
                default: null
            },
            isAddMode: {
                type: Boolean,
                default: false
            }
        },
        emits: ['saved'],
        setup(props: any, { emit }: any) {
            const isSaving = ref(false)
            const isDataLoaded = ref(false)
            
            const companiesList = ref<any[]>([])
            const cityList = ref<any[]>([])
            const genderList = ref<any[]>([])
            const documentTypesList = ref<any[]>([])
            const nationalityList = ref<any[]>([])
            const conveyanceListArray = ref([
                { id: 1, name: "Car" }, 
                { id: 2, name: "Motor Bike" }, 
                { id: 3, name: "Public Tpt" }, 
                { id: 4, name: "Bike" }
            ])
            
            const selectedConveyanceName = ref("")
            const selectedCityName = ref("")
            const selectedGenderType = ref("")
            const selectedNationality = ref("")
            const selectedCountryOfBirth = ref("")
            const selectedAddressCountry = ref("")
            const selectedIdDocumentCountryOfIssue = ref("")
            const selectedIdDocumentName = ref("")
            
            const idDocumentNumber = ref("")
            const idDocumentIssueDate = ref("")
            const idDocumentExpiryDate = ref("")
            const idDocumentId = ref<number | null>(null)
            
            const formData = ref({
                SecurityOfficerId: 0,
                FirstName: '',
                LastName: '',
                PreviouslyKnownAs: '',
                MobileNumber: '',
                Email: '',
                Phone2: '',
                SiabadageNumber: '',
                SiaExpiryDate: '',
                Ninumber: '',
                HouseNameNumber: '',
                StreetAdress: '',
                County: '',
                PostCode: '',
                NextOfKin: '',
                DateOfBirth: '',
                PlaceOfBirth: '',
                PassportNo: '',
                PassportExpiryDate: '',
                VisaExpiryDate: '',
                SecurityCompanyId: '',
                Active: true,
                Town: '',
                PassportId: null,
                IdentityDocumentId: null,
                PayRate: '0',
                CityId: 0,
                ConveyanceId: 0
            })
            
            const isPrivacyPolicyAgreed = ref(false)

            const formatDateForInput = (apiDate: string | null): string => {
                if (!apiDate) return ""
                const match = apiDate.match(/^(\d{4}-\d{2}-\d{2})/)
                return match ? match[1] : ""
            }

            const formatDateForDisplay = (dateValue: string) => {
                if (!dateValue) return ""
                const parts = dateValue.split('-')
                if (parts.length === 3) {
                    return `${parts[2]}/${parts[1]}/${parts[0]}`
                }
                return dateValue
            }

            const loadData = async () => {
                //console.log("=== loadData called, isAddMode:", props.isAddMode, "officerId:", props.officerId)
                
                const token = localStorage.token
                const headers = {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }

                try {
                    const [companiesRes, utilityRes, citiesRes] = await Promise.all([
                        fetch(props.baseUrl + "Companies/Companies", { headers }),
                        fetch(props.baseUrl + "SecurityOfficers/GenderAndDocumentTypesAndNationalityList", { headers }),
                        fetch(props.baseUrl + "Cities/Cities", { headers })
                    ])

                    const companiesData = await companiesRes.json()
                    const utilityData = await utilityRes.json()
                    const citiesData = await citiesRes.json()

                    companiesList.value = companiesData || []
                    genderList.value = utilityData?.utilityService?.gendersList || []
                    documentTypesList.value = utilityData?.utilityService?.documentTypesList || []
                    nationalityList.value = utilityData?.utilityService?.nationalityList || []
                    cityList.value = citiesData?.cities || []

                    //console.log("Lists loaded - cities:", cityList.value.length, "nationalities:", nationalityList.value.length)

                    if (!props.isAddMode && props.officerId) {
                        //console.log("Edit mode - loading officer data for ID:", props.officerId)
                        
                        const profileRes = await fetch(props.baseUrl + "Securityofficers/OfficerFullDetailById", {
                            method: "POST",
                            headers,
                            body: JSON.stringify({ "Id": parseInt(props.officerId) })
                        })
                        const profileData = await profileRes.json()
                        
                        const data = profileData.officerFullDetailViewModel
                        if (data) {
                            formData.value = {
                                SecurityOfficerId: data.securityOfficerId || 0,
                                FirstName: data.firstName || '',
                                LastName: data.lastName || '',
                                PreviouslyKnownAs: data.previouslyKnownAs || '',
                                MobileNumber: data.mobileNumber || '',
                                Email: data.email || '',
                                Phone2: data.phone2 || '',
                                SiabadageNumber: data.siabadageNumber || '',
                                SiaExpiryDate: formatDateForInput(data.siaExpiryDate),
                                Ninumber: data.ninumber || '',
                                HouseNameNumber: data.houseNameNumber || '',
                                StreetAdress: data.streetAdress || '',
                                County: data.county || '',
                                PostCode: data.postCode || '',
                                NextOfKin: data.nextOfKin || '',
                                DateOfBirth: formatDateForInput(data.dateOfBirth),
                                PlaceOfBirth: data.placeOfBirth || '',
                                PassportNo: data.passport?.passportNo || '',
                                PassportExpiryDate: formatDateForInput(data.passport?.passportExpiryDate),
                                VisaExpiryDate: formatDateForInput(data.passport?.visaExpiryDate),
                                SecurityCompanyId: data.securityCompanyId || '',
                                Active: true,
                                Town: data.town || '',
                                PassportId: data.passportId || null,
                                IdentityDocumentId: data.identityDocumentId || null,
                                PayRate: data.payRate || '0',
                                CityId: data.cityId || 0,
                                ConveyanceId: data.conveyanceId || 0
                            }

                            const cityObj = cityList.value.find((c: any) => c.cityId === data.cityId)
                            const genderObj = genderList.value.find((g: any) => g.id === data.genderId)
                            const nationalityObj = nationalityList.value.find((n: any) => n.id === data.nationalityId)
                            const birthCountryObj = nationalityList.value.find((n: any) => n.id === data.countryOfBirthId)
                            const addressCountryObj = nationalityList.value.find((n: any) => n.id === data.addressCountryId)
                            
                            selectedCityName.value = cityObj?.name || ''
                            selectedGenderType.value = genderObj?.name || ''
                            selectedNationality.value = nationalityObj?.name || ''
                            selectedCountryOfBirth.value = birthCountryObj?.name || ''
                            selectedAddressCountry.value = addressCountryObj?.name || ''
                            selectedConveyanceName.value = conveyanceListArray.value.find(c => c.id === data.conveyanceId)?.name || ''
                            
                            if (data.identityDocument) {
                                idDocumentNumber.value = data.identityDocument.number || ''
                                idDocumentIssueDate.value = formatDateForInput(data.identityDocument.issueDate)
                                idDocumentExpiryDate.value = formatDateForInput(data.identityDocument.expiryDate)
                                idDocumentId.value = data.identityDocument.id || null
                                
                                const docCountryObj = nationalityList.value.find((n: any) => n.id === data.identityDocument.countryOfIssueId)
                                selectedIdDocumentCountryOfIssue.value = docCountryObj?.name || ''
                                
                                const docTypeObj = documentTypesList.value.find((d: any) => d.id === data.identityDocument.typeId)
                                selectedIdDocumentName.value = docTypeObj?.name || ''
                            }
                        }
                    } else {
                        //console.log("Add mode - keeping empty form")
                        formData.value = {
                            SecurityOfficerId: 0,
                            FirstName: '',
                            LastName: '',
                            PreviouslyKnownAs: '',
                            MobileNumber: '',
                            Email: '',
                            Phone2: '',
                            SiabadageNumber: '',
                            SiaExpiryDate: '',
                            Ninumber: '',
                            HouseNameNumber: '',
                            StreetAdress: '',
                            County: '',
                            PostCode: '',
                            NextOfKin: '',
                            DateOfBirth: '',
                            PlaceOfBirth: '',
                            PassportNo: '',
                            PassportExpiryDate: '',
                            VisaExpiryDate: '',
                            SecurityCompanyId: '',
                            Active: true,
                            Town: '',
                            PassportId: null,
                            IdentityDocumentId: null,
                            PayRate: '0',
                            CityId: 0,
                            ConveyanceId: 0
                        }
                        selectedCityName.value = ''
                        selectedGenderType.value = ''
                        selectedNationality.value = ''
                        selectedCountryOfBirth.value = ''
                        selectedAddressCountry.value = ''
                        selectedConveyanceName.value = ''
                        selectedIdDocumentName.value = ''
                        selectedIdDocumentCountryOfIssue.value = ''
                        idDocumentNumber.value = ''
                        idDocumentIssueDate.value = ''
                        idDocumentExpiryDate.value = ''
                        idDocumentId.value = null
                    }
                    
                    isDataLoaded.value = true
                } catch (error) {
                    console.error("Load error:", error)
                }
            }
                    
            const UpdateOfficer = async () => {
                if (!isPrivacyPolicyAgreed.value) {
                    alert("Please read and agree to the Privacy Policy.")
                    return
                }

                if (!props.isAddMode && !formData.value.SecurityOfficerId) {
                    alert("Invalid officer data")
                    return
                }

                const cityObj = cityList.value.find((c: any) => c.name === selectedCityName.value)
                if (!cityObj) { 
                    alert(`Please select a valid city. "${selectedCityName.value}" not found.`)
                    return 
                }
                const cityId = cityObj.cityId

                const genderObj = genderList.value.find((g: any) => g.name === selectedGenderType.value)
                if (!genderObj) { 
                    alert(`Please select a valid gender. "${selectedGenderType.value}" not found.`)
                    return 
                }
                const genderId = genderObj.id

                const nationalityObj = nationalityList.value.find((n: any) => n.name === selectedNationality.value)
                if (!nationalityObj) { 
                    alert(`Please select a valid nationality. "${selectedNationality.value}" not found.`)
                    return 
                }
                const nationalityId = nationalityObj.id

                const countryOfBirthObj = nationalityList.value.find((n: any) => n.name === selectedCountryOfBirth.value)
                if (!countryOfBirthObj) { 
                    alert(`Please select a valid country of birth. "${selectedCountryOfBirth.value}" not found.`)
                    return 
                }
                const countryOfBirthId = countryOfBirthObj.id

                const addressCountryObj = nationalityList.value.find((n: any) => n.name === selectedAddressCountry.value)
                if (!addressCountryObj) { 
                    alert(`Please select a valid address country. "${selectedAddressCountry.value}" not found.`)
                    return 
                }
                const addressCountryId = addressCountryObj.id

                const conveyanceObj = conveyanceListArray.value.find(c => c.name === selectedConveyanceName.value)
                if (!conveyanceObj) { 
                    alert(`Please select a valid conveyance. "${selectedConveyanceName.value}" not found.`)
                    return 
                }
                const conveyanceId = conveyanceObj.id

                const documentTypeObj = documentTypesList.value.find((d: any) => d.name === selectedIdDocumentName.value)
                if (!documentTypeObj && selectedIdDocumentName.value) { 
                    alert(`Please select a valid document type. "${selectedIdDocumentName.value}" not found.`)
                    return 
                }
                const documentTypeId = documentTypeObj?.id || null

                const idDocumentCountryObj = nationalityList.value.find((n: any) => n.name === selectedIdDocumentCountryOfIssue.value)
                if (!idDocumentCountryObj && selectedIdDocumentCountryOfIssue.value) { 
                    alert(`Please select a valid document country of issue. "${selectedIdDocumentCountryOfIssue.value}" not found.`)
                    return 
                }
                const idDocumentCountryId = idDocumentCountryObj?.id || null

                isSaving.value = true

                let payload;
                
                if (props.isAddMode) {
                    payload = {
                        FirstName: formData.value.FirstName,
                        LastName: formData.value.LastName,
                        PostCode: formData.value.PostCode,
                        CityId: cityId,
                        County: formData.value.County,
                        StreetAdress: formData.value.StreetAdress,
                        Town: formData.value.Town || "",
                        Active: formData.value.Active,
                        SecurityCompanyId: parseInt(formData.value.SecurityCompanyId) || 0,
                        SiabadageNumber: formData.value.SiabadageNumber,
                        MobileNumber: formData.value.MobileNumber,
                        Ninumber: formData.value.Ninumber,
                        DesignationId: null,
                        DeptId: null,
                        ConveyanceId: conveyanceId,
                        Email: formData.value.Email,
                        SiaExpiryDate: formData.value.SiaExpiryDate,
                        Phone2: formData.value.Phone2 || "",
                        NextOfKin: formData.value.NextOfKin,
                        PreviouslyKnownAS: formData.value.PreviouslyKnownAs || "",
                        DateOfBirth: formData.value.DateOfBirth,
                        PlaceOfBirth: formData.value.PlaceOfBirth,
                        HouseNameNumber: formData.value.HouseNameNumber,
                        CountryOfBirthId: countryOfBirthId,
                        AddressCountryId: addressCountryId,
                        NationalityId: nationalityId,
                        GenderId: genderId,
                        IdentityDocument: {
                            Id: 0,
                            IssueDate: idDocumentIssueDate.value || null,
                            ExpiryDate: idDocumentExpiryDate.value || null,
                            CountryOfIssueId: idDocumentCountryId,
                            Number: idDocumentNumber.value || "",
                            TypeId: documentTypeId
                        },
                        Passport: {
                            PassportNo: formData.value.PassportNo || "",
                            PassportExpiryDate: formData.value.PassportExpiryDate || null,
                            VisaExpiryDate: formData.value.VisaExpiryDate || null,
                            Nationality: ""
                        }
                    }
                } else {
                    payload = {
                        SecurityOfficerId: formData.value.SecurityOfficerId,
                        FirstName: formData.value.FirstName,
                        LastName: formData.value.LastName,
                        PostCode: formData.value.PostCode,
                        CityId: cityId,
                        County: formData.value.County,
                        StreetAdress: formData.value.StreetAdress,
                        Town: formData.value.Town || "",
                        Active: formData.value.Active,
                        SecurityCompanyId: parseInt(formData.value.SecurityCompanyId) || 0,
                        SiabadageNumber: formData.value.SiabadageNumber,
                        MobileNumber: formData.value.MobileNumber,
                        Ninumber: formData.value.Ninumber,
                        DesignationId: null,
                        DeptId: null,
                        PassportId: formData.value.PassportId,
                        ConveyanceId: conveyanceId,
                        Email: formData.value.Email,
                        SiaExpiryDate: formData.value.SiaExpiryDate,
                        Phone2: formData.value.Phone2 || "",
                        NextOfKin: formData.value.NextOfKin,
                        PreviouslyKnownAS: formData.value.PreviouslyKnownAs || "",
                        DateOfBirth: formData.value.DateOfBirth,
                        PlaceOfBirth: formData.value.PlaceOfBirth,
                        HouseNameNumber: formData.value.HouseNameNumber,
                        IdentityDocumentId: idDocumentId.value,
                        CountryOfBirthId: countryOfBirthId,
                        AddressCountryId: addressCountryId,
                        NationalityId: nationalityId,
                        GenderId: genderId,
                        IdentityDocument: {
                            Id: idDocumentId.value || 0,
                            IssueDate: idDocumentIssueDate.value || null,
                            ExpiryDate: idDocumentExpiryDate.value || null,
                            CountryOfIssueId: idDocumentCountryId,
                            Number: idDocumentNumber.value || "",
                            TypeId: documentTypeId
                        },
                        Passport: {
                            PassportNo: formData.value.PassportNo || "",
                            PassportExpiryDate: formData.value.PassportExpiryDate || null,
                            VisaExpiryDate: formData.value.VisaExpiryDate || null,
                            Nationality: ""
                        }
                    }
                }

                console.log("Sending payload:", payload)

                const endpoint = props.isAddMode 
                    ? "SecurityOfficers/AddSecurityOfficer"
                    : "SecurityOfficers/UpdateSecurityOfficerByOfficerHimself"

                try {
                    const response = await fetch(props.baseUrl + endpoint, {
                        method: "POST",
                        headers: {
                            "Authorization": `Bearer ${localStorage.token}`,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(payload)
                    })

                    const responseText = await response.text()
                    console.log("Response:", response.status, responseText)

                    if (response.ok) {
                        alert(props.isAddMode ? "Officer added successfully!" : "Profile updated successfully!");
                        emit('saved');
                        
                        const closeButton = document.querySelector('#UpdateOfficerModal .btn-close') as HTMLElement;
                        if (closeButton) {
                            closeButton.click();
                        }
                        
                        setTimeout(() => {
                            const backdrops = document.querySelectorAll('.modal-backdrop');
                            backdrops.forEach(backdrop => backdrop.remove());
                            document.body.classList.remove('modal-open');
                        }, 150);
                    } else {
                        alert(`${props.isAddMode ? 'Add' : 'Update'} failed: ${response.status} ${responseText}`)
                    }
                } catch (error) {
                    console.error("Error:", error)
                    alert("An error occurred. Please try again.")
                } finally {
                    isSaving.value = false
                }
            }

            watch(() => props.officerId, (newId) => {
                //console.log("Watch triggered with ID:", newId);
                loadData();
            }, { immediate: true })

            onMounted(() => {
                //console.log("Component mounted");
                loadData();
            })

            return {
                formData,
                companiesList,
                cityList,
                genderList,
                documentTypesList,
                nationalityList,
                conveyanceListArray,
                selectedConveyanceName,
                selectedCityName,
                selectedGenderType,
                selectedNationality,
                selectedCountryOfBirth,
                selectedAddressCountry,
                selectedIdDocumentCountryOfIssue,
                selectedIdDocumentName,
                idDocumentNumber,
                idDocumentIssueDate,
                idDocumentExpiryDate,
                isPrivacyPolicyAgreed,
                isSaving,
                formatDateForDisplay,
                UpdateOfficer,
                //isAddMode: props.isAddMode
            }
        },
    })
</script>

<style scoped>
.profile-form-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.form-section {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
  background: #fff;
}

.section-title {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #007bff;
  color: #333;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
}

.form-row label {
  width: 160px;
  min-width: 160px;
  font-weight: 500;
  color: #555;
}

.form-row input:not([type="checkbox"]),
.form-row select {
  flex: 1;
  min-width: 200px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.form-row input:focus,
.form-row select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.date-input-group {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.date-display {
  color: #666;
  font-size: 13px;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 4px;
}

.date-input-group input {
  flex: 1;
  min-width: 150px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.checkbox-row input {
  width: 20px;
  height: 20px;
  margin: 0;
  cursor: pointer;
}

.checkbox-row label {
  width: auto;
  min-width: auto;
  font-weight: normal;
  cursor: pointer;
}

.checkbox-row a {
  color: #007bff;
  text-decoration: none;
}

.checkbox-row a:hover {
  text-decoration: underline;
}

.required {
  color: #dc3545;
  margin-left: 2px;
}

.button-row {
  text-align: center;
  margin-top: 24px;
}

.btn-primary {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 32px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-primary:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* ============================================ */
/* MOBILE RESPONSIVE STYLES (768px and below) */
/* ============================================ */
@media (max-width: 768px) {
  .profile-form-container {
    padding: 12px;
  }

  .form-section {
    padding: 15px;
    margin-bottom: 16px;
  }

  .section-title {
    font-size: 16px;
    margin-bottom: 15px;
    padding-bottom: 8px;
  }

  .form-row {
    gap: 8px;
    margin-bottom: 12px;
  }

  .form-row label {
    width: 100px;
    min-width: 100px;
    font-size: 13px;
  }

  .form-row input:not([type="checkbox"]),
  .form-row select {
    flex: 1;
    min-width: unset;
    padding: 6px 10px;
    font-size: 13px;
  }

  .date-input-group {
    flex: 1;
    gap: 8px;
  }

  .date-display {
    font-size: 11px;
    padding: 3px 6px;
  }

  .date-input-group input {
    min-width: unset;
    padding: 6px 10px;
    font-size: 13px;
  }

  .checkbox-row {
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
  }

  .checkbox-row input {
    width: 18px;
    height: 18px;
  }

  .checkbox-row label {
    font-size: 12px;
  }

  .required {
    font-size: 12px;
  }

  .button-row {
    margin-top: 16px;
  }

  .btn-primary {
    padding: 8px 24px;
    font-size: 14px;
  }
}

/* ============================================ */
/* SMALL MOBILE (480px and below) */
/* ============================================ */
/* SMALL MOBILE (480px and below) - Keep same line */
@media (max-width: 480px) {
  .profile-form-container {
    padding: 8px;
  }

  .form-section {
    padding: 12px;
    margin-bottom: 12px;
  }

  .section-title {
    font-size: 14px;
    margin-bottom: 12px;
  }

  /* Keep horizontal layout on small phones too */
  .form-row {
    flex-direction: row;
    align-items: center;
    gap: 6px;
    margin-bottom: 12px;
  }

  .form-row label {
    width: 70px;
    min-width: 70px;
    font-size: 11px;
    font-weight: 500;
  }

  .form-row input:not([type="checkbox"]),
  .form-row select {
    flex: 1;
    padding: 6px 8px;
    font-size: 12px;
  }

  .date-input-group {
    flex: 1;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }

  .date-display {
    font-size: 9px;
    padding: 2px 4px;
  }

  .date-input-group input {
    flex: 1;
    padding: 6px 8px;
    font-size: 12px;
  }

  .checkbox-row {
    flex-direction: row;
    align-items: center;
    gap: 6px;
  }

  .checkbox-row input {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  .checkbox-row label {
    flex: 1;
    font-size: 10px;
    line-height: 1.3;
  }

  .button-row {
    margin-top: 16px;
  }

  .btn-primary {
    width: 100%;
    padding: 10px;
    font-size: 14px;
  }
}
</style>